var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"action-header"},[_c('el-button',{attrs:{"icon":"el-icon-plus","type":"primary"},on:{"click":_vm.showDialog}},[_vm._v("新建用户")])],1),_c('Table'),_c('Pagination'),_c('DialogUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }